// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__vps_j","sidebar":"Layout_sidebar__2EpYu","main":"Layout_main__3OBIG"};